import { Action } from '@ngrx/store';

export const TOGGLE_COLLAPSED = '[Toggle] Toggle Collpased';
export class ToggleCollapsed implements Action {
    type = TOGGLE_COLLAPSED;
    constructor() {}
}

export const SET_COLLAPSED = '[Toggle] Set Collpased';
export class SetCollapsed implements Action {
    type = SET_COLLAPSED;
    constructor(public collapsed: boolean) {}
}

export const SHOW_ASIDE_PRIMARY = '[Toggle] Show primary';
export class ShowAsidePrimary implements Action {
    type = SHOW_ASIDE_PRIMARY;
    constructor(public idLayout: string) {}
}

export const CLOSE_ASIDE_PRIMARY = '[Toggle] Close primary';
export class CloseAsidePrimary implements Action {
    type = CLOSE_ASIDE_PRIMARY;
    constructor() {}
}

export const SHOW_ASIDE_SECONDARY = '[Toggle] Show Aside Secondary';
export class ShowAsideSecondary implements Action {
    type = SHOW_ASIDE_SECONDARY;
    constructor(public idLayout: string, public params?: any) {}
}

export const CLOSE_ASIDE_SECONDARY = '[Toggle] Close Aside Secondary';
export class CloseAsideSecondary implements Action {
    type = CLOSE_ASIDE_SECONDARY;
    constructor() {}
}

export const SHOW_MENU = '[Toggle] Show Menu';
export class ShowMenu implements Action {
    type = SHOW_MENU;
    constructor() {}
}

export const TOGGLE_MENU = '[Toggle] Toggle Menu';
export class ToggleMenu implements Action {
    type = TOGGLE_MENU;
    constructor() {}
}

export const ANONYMOUS = '[Toggle] Anonymous';
export class Anonymous implements Action {
    type = ANONYMOUS;
    constructor() {}
}

export const ANONYMOUS_OFF = '[Toggle] Anonymous Off';
export class AnonymousOff implements Action {
    type = ANONYMOUS_OFF;
    constructor() {}
}

export const CLOSE_MENU = '[Toggle] Close Menu';
export class CloseMenu implements Action {
    type = CLOSE_MENU;
    constructor() {}
}

export const BACK = '[Toggle] Back';
export class Back implements Action {
    type = BACK;
    constructor() {}
}

export type All =
    | ToggleCollapsed
    | SetCollapsed
    | ShowAsidePrimary
    | CloseAsidePrimary
    | ShowAsideSecondary
    | CloseAsideSecondary
    | ShowMenu
    | CloseMenu
    | Anonymous
    | AnonymousOff
    | Back;
